import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
    type MenuItems,
    type SubmenuItem,
} from "@bloomberg/media-ui-nav/dist/types";

const initialState: {
    menuItems: MenuItems;
    footerMenuItems: Record<string, SubmenuItem>;
} = {
    menuItems: {
        menuItemsDesktop: {},
        menuItemsMobile: {},
    },
    footerMenuItems: {},
};

const navMenuItemsSlice = createSlice({
    name: "navMenuItems",
    initialState,
    reducers: {
        menuItemsFetched(state, action: PayloadAction<MenuItems>) {
            Object.assign(state.menuItems, action.payload);
        },
        footerMenuItemsFetched(
            state,
            action: PayloadAction<Record<string, SubmenuItem>>
        ) {
            Object.assign(state.footerMenuItems, action.payload);
        },
    },
});

export const { menuItemsFetched, footerMenuItemsFetched } =
    navMenuItemsSlice.actions;

export default navMenuItemsSlice.reducer;
